<script>
import api from '@utils/api'
// import { isNil } from 'lodash'
// import { getDocumentTypeId } from '@utils/transformations'
// import * as compare from '@utils/comparers'
import ConfirmCancelFinalize from './confirm-cancel-finalize'
import SerialSearch from '@components/serial-search'
import { createBarcodeScanner, isMobile } from '@utils/barcode/barcode-scanner'
import { getGoodsGroup } from '../../../utils/goods-group'

export default {
  name: 'DocumentChangeNew',
  components: { ConfirmCancelFinalize, SerialSearch },
  props: {
    dialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
      pdo: {
        loading: false,
        serial: null,
        info: [],
        goods: null,
        organization: null,
        warehouse: null,
      },
      plug: {
        loading: false,
        serial: null,
        info: [],
        goods: null,
        organization: null,
        warehouse: null,
      },
      cancelDialog: false,
      scannerIsVisible: false,
      barcodeScanner: createBarcodeScanner(document),
      isMobile: isMobile(),
    }
  },
  computed: {
    getPDOGoods() {
      return this.pdo.goods
    },
    getPlugGoods() {
      return this.plug.goods
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  watch: {
    getPDOGoods(value) {
      if (!value) return
      const item = this.pdo.info.find(item => item.goodsId === value)
      this.pdo.organization = item.organizationId
      this.pdo.warehouse = item.warehouseId
    },
    getPlugGoods(value) {
      if (!value) return
      const item = this.plug.info.find(item => item.goodsId === value)
      this.plug.organization = item.organizationId
      this.plug.warehouse = item.warehouseId
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    checkPDOSerial() {
      if (!this.pdo.serial) return
      this.pdo.loading = true
      api
        .getGoodsBySerial({
          serial: this.pdo.serial,
          in_my_organization: false,
        })
        .then(response => {
          // Check if this is not master organization
          let data = response.data
          if (
            data.length > 0 &&
            (data[0].organizationId === 1 ||
              getGoodsGroup(this.goods, data[0].goodsId) === 2 ||
              getGoodsGroup(this.goods, data[0].goodsId) === 3)
          ) {
            response.data.length = 0
          }
          if (response.data.length === 0) {
            this.$store.commit('notifications/ADD', {
              type: 'warning',
              message: this.$t('error__serial_not_found'),
            })
            this.pdo.info = []
            this.pdo.goods = null
            this.pdo.organization = null
            this.pdo.warehouse = null
          } else {
            this.pdo.info = response.data
            if (response.data.length === 1)
              this.pdo.goods = response.data[0].goodsId
          }
          this.pdo.loading = false
        })
        .catch(() => {})
        .then(() => {
          this.pdo.loading = false
        })
    },
    checkPlugSerial() {
      if (!this.plug.serial) return
      this.plug.loading = true
      api
        .getGoodsBySerial({
          serial: this.plug.serial,
          in_my_organization: true,
        })
        .then(response => {
          // Check if this is plug
          if (
            response.data.length > 0 &&
            getGoodsGroup(this.goods, response.data[0].goodsId) !== 2
          ) {
            response.data.length = 0
          }
          if (response.data.length === 0) {
            this.$store.commit('notifications/ADD', {
              type: 'warning',
              message: this.$t('error__serial_not_found'),
            })
            this.plug.info = []
            this.plug.goods = null
            this.plug.organization = null
            this.plug.warehouse = null
          } else {
            this.plug.info = response.data
            if (response.data.length === 1)
              this.plug.goods = response.data[0].goodsId
          }
          this.plug.loading = false
        })
        .catch(() => {})
        .then(() => {
          this.plug.loading = false
        })
    },
    closeItem() {
      this.loading = false
      this.cancelDialog = false
      this.$refs.newItemForm.reset()
      this.resetForm()
      this.$emit('close-modal')
    },
    resetForm() {
      this.pdo = {
        loading: false,
        serial: null,
        info: [],
        goods: null,
        organization: null,
        warehouse: null,
      }
      this.plug = {
        loading: false,
        serial: null,
        info: [],
        goods: null,
        organization: null,
        warehouse: null,
      }
    },
    submit() {
      if (this.$refs.newItemForm.validate()) {
        this.loading = true
        const data = {
          pdoSerial: this.pdo.serial,
          pdoWarehouse: this.pdo.warehouse,
          plugSerial: this.plug.serial,
          plugWarehouse: this.plug.warehouse,
        }
        api.changePlug(data).then(response => {
          if (response) {
            this.$emit('document-created')
            this.closeItem()
          } else {
            this.$store.commit('notifications/ADD', {
              type: 'error',
              message: this.$t('error__cant_change_plug'),
            })
          }
          this.loading = false
        })
      } else {
        this.$store.commit('notifications/ADD', {
          type: 'error',
          message: this.$t('error__fill_fields'),
        })
      }
    },
    setPDOSerial(value) {
      this.pdo.serial = value
      this.checkPDOSerial()
    },
    setPlugSerial(value) {
      this.plug.serial = value
      this.checkPlugSerial()
    },
    selectedPDOSerial(value) {
      this.pdo.serial = value
    },
    selectedPlugSerial(value) {
      this.plug.serial = value
    },
    openBarcodeScanner(field, applyValueFn) {
      this.scannerIsVisible = true
      this.barcodeScanner.openScannerForField(
        value => applyValueFn(value),
        () => this.closeScanner()
      )
    },
    closeScanner() {
      this.barcodeScanner.closeScanner()
      this.scannerIsVisible = false
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    :content-class="$style.relativePosition"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__new_document') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newItemForm"
                v-model="valid"
                lazy-validation
              >
                <v-layout
                  row
                  align-center
                >
                  <v-flex>
                    <serial-search
                      :value="pdo.serial"
                      :not-in-my-organization="true"
                      label="label__replaced_plug_sn"
                      @selected="setPDOSerial($event)"
                    />
                  </v-flex>
                  <v-flex
                    v-if="isMobile"
                    shrink>
                    <img
                      class="barcodeScanIcon"
                      src="@assets/images/barcode_scan_icon.png"
                      @click="openBarcodeScanner('serial', selectedPDOSerial)"
                    >
                  </v-flex>
                  <!-- <v-flex>
                    <v-text-field
                      :label="$t('label__replaced_plug_sn')"
                      v-model="pdo.serial"
                      :rules="rules.isRequired"
                      :loading="pdo.loading"
                      :disabled="pdo.loading"
                      required
                      @keyup.enter="checkPDOSerial()"
                    />
                  </v-flex>
                  <v-flex shrink>
                    <v-btn
                      :disabled="pdo.loading || !pdo.serial"
                      :loading="pdo.loading"
                      color="primary"
                      flat
                      icon
                      @click.prevent="checkPDOSerial()"
                    >
                      <v-icon>get_app</v-icon>
                    </v-btn>
                  </v-flex> -->
                </v-layout>
                <v-select
                  :items="pdo.info"
                  :label="$t('label__replaced_plug')"
                  :disabled="!pdo.info.length < 2"
                  :rules="rules.isRequired"
                  v-model="pdo.goods"
                  item-text="goodsShortName"
                  item-value="goodsId"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__from')"
                  :value="getValue('organization', pdo.organization)"
                  :rules="rules.isRequired"
                  disabled
                  required
                />
                <v-text-field
                  :label="$t('label__fromWarehouse')"
                  :value="getValue('organization', pdo.warehouse)"
                  :rules="rules.isRequired"
                  disabled
                  required
                />
                <!-- Новая пробка -->
                <v-layout
                  row
                  align-center
                >
                  <v-flex>
                    <serial-search
                      :value="plug.serial"
                      :in-my-organization="true"
                      label="label__new_plug_sn"
                      @selected="setPlugSerial($event)"
                    />
                  </v-flex>
                  <v-flex
                    v-if="isMobile"
                    shrink>
                    <img
                      class="barcodeScanIcon"
                      src="@assets/images/barcode_scan_icon.png"
                      @click="openBarcodeScanner('serial', selectedPlugSerial)"
                    >
                  </v-flex>
                  <!-- <v-flex>
                    <v-text-field
                      :label="$t('label__new_plug_sn')"
                      v-model="plug.serial"
                      :rules="rules.isRequired"
                      :loading="plug.loading"
                      :disabled="plug.loading"
                      required
                      @keyup.enter="checkPlugSerial()"
                    />
                  </v-flex>
                  <v-flex shrink>
                    <v-btn
                      :disabled="plug.loading || !plug.serial"
                      :loading="plug.loading"
                      color="primary"
                      flat
                      icon
                      @click.prevent="checkPlugSerial()"
                    >
                      <v-icon>get_app</v-icon>
                    </v-btn>
                  </v-flex> -->
                </v-layout>
                <v-select
                  :items="plug.info"
                  :label="$t('label__new_plug')"
                  :disabled="!plug.info.length < 2"
                  :rules="rules.isRequired"
                  v-model="plug.goods"
                  item-text="goodsShortName"
                  item-value="goodsId"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__to')"
                  :value="getValue('organization', plug.organization)"
                  :rules="rules.isRequired"
                  disabled
                  required
                />
                <v-text-field
                  :label="$t('label__toWarehouse')"
                  :value="getValue('organization', plug.warehouse)"
                  :rules="rules.isRequired"
                  disabled
                  required
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="cancelDialog = true">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="success"
          @click="submit">{{ $t('buttons__finalize') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-show="scannerIsVisible"
      id="scanner-container"
      class="scannerContainer">
      <v-btn
        class="scannerCancelBtn"
        color="secondary"
        @click="closeScanner()"
      >
        {{ $t('buttons__cancel') }}
      </v-btn>
    </v-card>
    <div
      v-if="scannerIsVisible"
      class="blurred"/>
    <confirm-cancel-finalize
      :dialog="cancelDialog"
      @close-modal="cancelDialog = false"
      @cancel-finalize="closeItem()"
    />
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.relativePosition {
  position: relative;
}
</style>
